import { createContext } from "react";

export enum AutopilotCuratedSearchTypeEnum {
  Internal = "INTERNAL",
  LinkedinSalesNavigator = "LINKEDIN_SALES_NAVIGATOR",
}

interface IAutopilotCuratedSearchContext {
  searchType: AutopilotCuratedSearchTypeEnum;
  selectedPrompt: string;
  setSelectedPrompt: (prompt: string | null) => void;
  specificCompanies: string[];
  setSpecificCompanies: (companies: string[]) => void;
  upsertAutopilotCuratedSearchLoading: boolean;
  setStartedGeneratingFilters: (value: boolean) => void;
  startedGeneratingFilters: boolean;
  remixPrompt?: string;
  setRemixPrompt?: (prompt: string | null) => void;
  remixPromptOptions?: string[];
  setStartedRemixingFilters?: (value: boolean) => void;
  setShowRemixStep?: (value: boolean) => void;
  resetRemix?: () => void;
  reset: () => void;
  setScoringCriteriaValues: (value: string[]) => void;
  scoringCriteriaValues: string[];
  expandScoringCriteriaValues: string[];
  setExpandScoringCriteriaValues: (value: string[]) => void;
}

const AutopilotCuratedSearchContext =
  createContext<IAutopilotCuratedSearchContext>({
    searchType: AutopilotCuratedSearchTypeEnum.Internal,
    selectedPrompt: "",
    setSelectedPrompt: () => {},
    specificCompanies: [] as string[],
    setSpecificCompanies: (companies: string[]) => {
      return;
    },
    upsertAutopilotCuratedSearchLoading: false,
    setStartedGeneratingFilters: () => {},
    startedGeneratingFilters: false,
    remixPrompt: "",
    setRemixPrompt: () => {},
    remixPromptOptions: [],
    setStartedRemixingFilters: () => {},
    setShowRemixStep: () => {},
    resetRemix: () => {},
    reset: () => {},
    setScoringCriteriaValues: () => {},
    scoringCriteriaValues: [] as string[],
    expandScoringCriteriaValues: [] as string[],
    setExpandScoringCriteriaValues: () => {},
  });

export default AutopilotCuratedSearchContext;
